module.exports = __webpack_public_path__ + "static/media/filter.b63381b2.svg";